import api from '../services/apiService';

// Lokaler Cache
let _holidays = null;
let _loadingPromise = null;

// Lade die Rohdaten einmalig
async function loadHolidays() {
  if (_holidays) return _holidays;
  if (!_loadingPromise) {
    _loadingPromise = api.get('/holidays').then(res => {
      // Wir merken uns Monat/Tag (1-basiert), Jahr (oder null) und isRecurring
      _holidays = res.data.map(h => ({
        month: h.month + 1,       // 0-basiert → 1-basiert
        day:   h.day,
        year:  h.isRecurring ? null : h.year, // null = jährlicher Feiertag
        isRecurring: h.isRecurring
      }));
      return _holidays;
    });
  }
  return _loadingPromise;
}

/**
 * Gibt true zurück, wenn das Datum ein Feiertag ist:
 * - ein wiederkehrender (isRecurring=true)
 * - oder eine Einmaligkeit mit passendem Jahr
 * @param {Date} date
 * @returns {boolean}
 */
export function isHoliday(date) {
  if (!_holidays) {
    // Starte das Laden asynchron, aber gib erstmal false zurück
    loadHolidays().catch(console.error);
    return false;
  }
  const m = date.getMonth() + 1;
  const d = date.getDate();
  const y = date.getFullYear();

  return _holidays.some(h =>
    h.month === m &&
    h.day   === d &&
    (h.isRecurring || h.year === y)
  );
}

export default {
  loadHolidays,
  isHoliday,
};
